import { logger } from '@/lib';
import { getAddressMetaFromId } from './addressOperations';
import { getFieldData } from './formOperations';

import { FPTI_FOCUS_AND_BLUR_EVENT_PAYLOAD } from '../fpti';
import type { DefaultInputState } from '@/store';
import type { AddressType, InputOnBlurChange } from '@/types';

const logBlurOrFocusEvent: InputOnBlurChange = (e): void => {
  const {
    target: { id },
    type,
  } = e;

  const { addressType } = getAddressMetaFromId(id);
  const { currentState } = getFieldData(e.target, {
    addressType: addressType as AddressType,
  });

  // If currentState is missing then return early
  // Eg: cardType is not having its own state and it is part of cardNumber
  if (!currentState) {
    logger.warn(`${id}_field_${type}_event_state_not_found`);
    return;
  }

  const { errorCode, isValid } = currentState as DefaultInputState;
  const payload = FPTI_FOCUS_AND_BLUR_EVENT_PAYLOAD({
    errorCode,
    eventType: type,
    fieldName: id,
    isValid,
  });

  logger.fpti(`${id}_field_${type}_event`, payload);
};

export { logBlurOrFocusEvent };
